export default __webpack_public_path__ + "static/media/menu_contact.c7097347.jpg";